
import React, { useState, useEffect } from 'react';

const steps = [
  {
    number: "01",
    title: "Подготовка воска",
    description: "Отбор и очистка натурального пчелиного воска высшего качества"
  },
  {
    number: "02",
    title: "Формовка",
    description: "Создание формы свечи с использованием традиционных техник"
  },
  {
    number: "03",
    title: "Охлаждение",
    description: "Медленное охлаждение для идеальной структуры"
  },
  {
    number: "04",
    title: "Контроль качества",
    description: "Тщательная проверка каждого изделия"
  }
];

const Process = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((current) => (current + 1) % steps.length);
    }, 12000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-24 bg-wax-50">
      <div className="container px-4">
        <h2 className="font-cormorant-garamond text-4xl font-bold text-center mb-16">
          Процесс создания
        </h2>
        <div className="grid md:grid-cols-4 gap-4">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`relative p-6 rounded-2xl cursor-pointer transition-all ${activeStep === index
                  ? "bg-honey-500 text-white shadow-lg scale-105"
                  : "bg-white hover:bg-honey-100"
                }`}
              onClick={() => setActiveStep(index)}
            >
              <span className={`absolute -top-6 left-6 text-6xl font-bold ${activeStep === index ? "text-honey-600" : "text-honey-200"
                }`}>
                {step.number}
              </span>
              <div className="pt-8">
                <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                <p className={activeStep === index ? "text-honey-50" : "text-gray-600"}>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
